import { useEffect, useState, useRef } from 'react';

const niches = [
  {
    name: 'Barbearias',
    icon: 'ri-scissors-cut-line',
    description: 'Agendamentos automáticos',
  },
  {
    name: 'Clínicas',
    icon: 'ri-hospital-line',
    description: 'Gestão de pacientes',
  },
  {
    name: 'Imobiliárias',
    icon: 'ri-building-2-line',
    description: 'Captação de leads',
  },
  {
    name: 'Concessionárias',
    icon: 'ri-car-line',
    description: 'Vendas automatizadas',
  },
  {
    name: 'Academias',
    icon: 'ri-heart-pulse-line',
    description: 'Retenção de alunos',
  },
  {
    name: 'Restaurantes',
    icon: 'ri-restaurant-line',
    description: 'Reservas e delivery',
  },
  {
    name: 'E-commerce',
    icon: 'ri-shopping-bag-line',
    description: 'Suporte 24/7',
  },
  {
    name: 'Consultórios',
    icon: 'ri-stethoscope-line',
    description: 'Confirmação de consultas',
  },
  {
    name: 'Escritórios',
    icon: 'ri-briefcase-line',
    description: 'Atendimento jurídico',
  },
  {
    name: 'Salões de Beleza',
    icon: 'ri-scissors-line',
    description: 'Agenda inteligente',
  },
  {
    name: 'Escolas',
    icon: 'ri-graduation-cap-line',
    description: 'Comunicação com pais',
  },
  {
    name: 'Hotéis',
    icon: 'ri-hotel-line',
    description: 'Reservas automatizadas',
  },
];

const partnerLogos = [
  { name: 'TechCorp', icon: 'ri-building-4-line' },
  { name: 'CloudSync', icon: 'ri-cloud-line' },
  { name: 'DataFlow', icon: 'ri-database-2-line' },
  { name: 'SmartBiz', icon: 'ri-lightbulb-line' },
  { name: 'ConnectHub', icon: 'ri-links-line' },
  { name: 'InnovateTech', icon: 'ri-rocket-2-line' },
];

export default function TrustedBySection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = sectionRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-12 sm:py-20 overflow-hidden bg-gradient-to-b from-black via-gray-900/30 to-black">
      {/* Background elements */}
      <div className="absolute inset-0 opacity-5">
        <div 
          className="absolute inset-0"
          style={{
            backgroundImage: `radial-gradient(circle at 2px 2px, rgba(0, 102, 255, 0.4) 1px, transparent 0)`,
            backgroundSize: '40px 40px',
          }}
        ></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
        {/* Section header */}
        <div 
          className={`text-center mb-10 sm:mb-14 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="inline-flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-white/5 text-gray-400 text-xs sm:text-sm font-medium rounded-full mb-3 sm:mb-4 border border-white/10">
            <i className="ri-verified-badge-line text-primary"></i>
            <span>Confiança de Diversos Segmentos</span>
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-3 sm:mb-4">
            Nichos que já <span className="text-primary">automatizaram</span> com a NeuroAgents
          </h2>
          <p className="text-gray-400 text-sm sm:text-base max-w-2xl mx-auto px-2">
            De pequenos negócios locais a grandes operações, nossa IA se adapta a qualquer segmento
          </p>
        </div>

        {/* Partner Logos Section */}
        <div 
          className={`mb-12 sm:mb-16 transition-all duration-700 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <p className="text-center text-gray-500 text-xs sm:text-sm mb-6 sm:mb-8 uppercase tracking-wider">
            Empresas que confiam na NeuroAgents
          </p>
          
          <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-10 md:gap-14">
            {partnerLogos.map((partner, index) => (
              <div
                key={partner.name}
                className={`group flex items-center gap-2 sm:gap-3 transition-all duration-500 hover:scale-110 cursor-pointer ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                }`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-lg bg-white/5 border border-white/10 group-hover:border-primary/50 group-hover:bg-white/10 transition-all duration-300">
                  <i className={`${partner.icon} text-lg sm:text-xl text-gray-400 group-hover:text-primary transition-colors duration-300`}></i>
                </div>
                <span className="text-gray-400 font-semibold text-sm sm:text-base group-hover:text-white transition-colors duration-300">
                  {partner.name}
                </span>
              </div>
            ))}
          </div>

          {/* Divider */}
          <div className="mt-10 sm:mt-12 flex items-center justify-center gap-4">
            <div className="h-px w-16 sm:w-24 bg-gradient-to-r from-transparent to-white/20"></div>
            <span className="text-gray-600 text-xs">SEGMENTOS ATENDIDOS</span>
            <div className="h-px w-16 sm:w-24 bg-gradient-to-l from-transparent to-white/20"></div>
          </div>
        </div>

        {/* Logos/Niches grid */}
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2 sm:gap-4 md:gap-6">
          {niches.map((niche, index) => (
            <div
              key={niche.name}
              className={`group transition-all duration-500 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 50}ms` }}
            >
              <div className="relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg sm:rounded-xl p-3 sm:p-5 text-center hover:border-primary/50 hover:bg-white/10 transition-all duration-300 cursor-pointer group-hover:scale-105">
                {/* Icon container */}
                <div className="w-9 h-9 sm:w-12 sm:h-12 mx-auto mb-2 sm:mb-3 rounded-lg bg-gradient-to-br from-primary/20 to-cyan-500/20 flex items-center justify-center group-hover:from-primary/30 group-hover:to-cyan-500/30 transition-all duration-300">
                  <i className={`${niche.icon} text-lg sm:text-2xl text-primary group-hover:text-white transition-colors duration-300`}></i>
                </div>
                
                {/* Name */}
                <h3 className="text-white font-semibold text-[10px] sm:text-sm mb-0.5 sm:mb-1 group-hover:text-primary transition-colors duration-300">
                  {niche.name}
                </h3>
                
                {/* Description */}
                <p className="text-gray-500 text-[8px] sm:text-xs hidden sm:block">
                  {niche.description}
                </p>

                {/* Hover glow */}
                <div className="absolute inset-0 rounded-lg sm:rounded-xl bg-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div 
          className={`mt-10 sm:mt-14 text-center transition-all duration-700 delay-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="inline-flex items-center gap-2 sm:gap-3 bg-white/5 border border-white/10 rounded-full px-4 sm:px-6 py-2 sm:py-3">
            <div className="flex -space-x-2">
              <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-gradient-to-br from-primary to-cyan-400 flex items-center justify-center text-white text-[10px] sm:text-xs font-bold border-2 border-black">
                <i className="ri-check-line"></i>
              </div>
              <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-gradient-to-br from-emerald-400 to-teal-500 flex items-center justify-center text-white text-[10px] sm:text-xs font-bold border-2 border-black">
                <i className="ri-check-line"></i>
              </div>
              <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-gradient-to-br from-violet-400 to-purple-500 flex items-center justify-center text-white text-[10px] sm:text-xs font-bold border-2 border-black">
                <i className="ri-check-line"></i>
              </div>
            </div>
            <span className="text-gray-300 text-xs sm:text-sm">
              <span className="text-white font-semibold">+500 empresas</span> já automatizaram
            </span>
          </div>
        </div>

        {/* Animated marquee effect - continuous scroll */}
        <div 
          className={`mt-8 sm:mt-12 overflow-hidden transition-all duration-700 delay-500 ${
            isVisible ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-8 text-gray-600 text-[10px] sm:text-sm">
            <div className="flex items-center gap-1 sm:gap-2">
              <i className="ri-shield-check-line text-primary"></i>
              <span>Implementação Segura</span>
            </div>
            <div className="hidden sm:block w-1 h-1 rounded-full bg-gray-700"></div>
            <div className="flex items-center gap-1 sm:gap-2">
              <i className="ri-customer-service-2-line text-primary"></i>
              <span>Suporte Dedicado</span>
            </div>
            <div className="hidden sm:block w-1 h-1 rounded-full bg-gray-700"></div>
            <div className="flex items-center gap-1 sm:gap-2">
              <i className="ri-settings-3-line text-primary"></i>
              <span>Personalização Total</span>
            </div>
            <div className="hidden sm:block w-1 h-1 rounded-full bg-gray-700"></div>
            <div className="flex items-center gap-1 sm:gap-2">
              <i className="ri-rocket-line text-primary"></i>
              <span>Ativação no Mesmo Dia</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
